// extracted by mini-css-extract-plugin
export default {"mainWrapper":"EachCard_mainWrapper__JDAtn","cardNumberTxt":"EachCard_cardNumberTxt__34T-8"};